'use client'

import { useTranslations } from 'next-intl'
import { useMemo } from 'react'
import { CommonSlider } from '../common/common-slider'

export function CoreValuesSection() {
    const t = useTranslations()

    const coreValues = useMemo(() => {
        return [
            {
                image: '/_images/jobs/core-values/core_values_1.webp',
                title: t('jobs.coreValues.items.first.title'),
                text: t('jobs.coreValues.items.first.description'),
            },
            {
                image: '/_images/jobs/core-values/core_values_2.webp',
                title: t('jobs.coreValues.items.second.title'),
                text: t('jobs.coreValues.items.second.description'),
            },
            {
                image: '/_images/jobs/core-values/core_values_3.webp',
                title: t('jobs.coreValues.items.third.title'),
                text: t('jobs.coreValues.items.third.description'),
            },
            {
                image: '/_images/jobs/core-values/core_values_4.webp',
                title: t('jobs.coreValues.items.fourth.title'),
                text: t('jobs.coreValues.items.fourth.description'),
            },
        ]
    }, [t])

    const headline = t('jobs.coreValues.title')

    return (
        <section className=" pb-20 md:pb-28 w-full flex flex-col items-center justify-center">
            <h1 className="text-center text-[24px] md:text-[32px] font-bold mb-4 md:mb-12 px-4">
                {headline}
            </h1>
            <CommonSlider type="content" content={coreValues} className="core-values-slider" />
        </section>
    )
}
